import { render } from "./cp1.vue?vue&type=template&id=b6ede2f8&scoped=true"
import script from "./cp1.vue?vue&type=script&lang=js"
export * from "./cp1.vue?vue&type=script&lang=js"

import "./cp1.vue?vue&type=style&index=0&id=b6ede2f8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b6ede2f8"

export default script